// v3.9 permissions - mirror of backend/app/core/permissions.py (used only until /auth/me returns the real list)
export const PERM_GROUPS = {
  view: ['warehouses.view', 'raw_materials.view', 'finished_goods.view', 'inventory.view', 'misc_goods.view', 'production.view',
    'purchases.view', 'shipments.view', 'sales.view', 'lading.view', 'transfers.view', 'accounting.view', 'expenses.view',
    'prepayments.view', 'payroll.view', 'costing.view', 'reports.view'],
  edit: ['production.edit', 'purchases.edit', 'sales.edit', 'expenses.edit', 'prepayments.edit', 'payroll.edit', 'accounting.edit', 'warehouses.manage', 'data.import'],
  sensitive: ['profit.view', 'records.delete', 'users.manage'],
};
export const ALL_PERMS = [...PERM_GROUPS.view, ...PERM_GROUPS.edit, ...PERM_GROUPS.sensitive];
const VIEW = PERM_GROUPS.view.filter(p => p !== 'payroll.view');   // salaries: admin / manager only by default
export const ROLE_DEFAULTS = {
  admin: ALL_PERMS,
  manager: ALL_PERMS.filter(p => !['users.manage', 'records.delete', 'warehouses.manage'].includes(p)),
  production_manager: [...VIEW, 'production.edit', 'purchases.edit', 'expenses.edit', 'prepayments.edit'],
  sales_manager: [...VIEW.filter(p => !['expenses.view', 'costing.view'].includes(p)), 'sales.edit', 'prepayments.edit'],
};
export const permsOf = (user) => {
  if (!user) return [];
  if (user.role === 'admin') return ALL_PERMS;
  return Array.isArray(user.permissions) ? user.permissions : (ROLE_DEFAULTS[user.role] || []);
};
// which page a route needs
export const ROUTE_PERM = {
  '/warehouses': 'warehouses.view', '/raw-materials': 'raw_materials.view', '/finished-goods': 'finished_goods.view',
  '/inventory': 'inventory.view', '/misc-goods': 'misc_goods.view', '/production': 'production.view', '/purchases': 'purchases.view',
  '/shipments': 'shipments.view', '/sales': 'sales.view', '/lading-bills': 'lading.view', '/transfers': 'transfers.view',
  '/accounting': 'accounting.view', '/expenses': 'expenses.view', '/prepayments': 'prepayments.view', '/payroll': 'payroll.view', '/import': 'data.import', '/costing': 'costing.view',
  '/reports': 'reports.view', '/report-builder': 'reports.view', '/users': 'users.manage', '/audit-log': 'users.manage',
};
